
import Api from '@/utils/api';
import MHeader from '../../Header/Header.vue';
import NotData from '../../NoData/NoData.vue';
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
data() {
return {
imgUrl: null,
invitedCount: 0
}
},
computed: {
},
components: {
MHeader,
Tab,
TabItem,
Swiper,
SwiperItem,
ViewBox,
NotData,
XImg,
Confirm
},
methods: {
},
mounted() {
if (!this.$store.state.userInfo.mobileNumber) {
this.$router.push({
name: 'bindMobileNumber',
params: {
ref: 'invite'
}
})
this.$vux.toast.text('请绑定手机号')
}
Api.getQrcode()
.then(res => {
this.imgUrl = res.data.imgUrl
})
Api.getUserInfo()
.then(res => {
if (res.data.invitedCount) {
this.invitedCount = res.data.invitedCount
}
})
}
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/invite/invite.vue